import React from "react";
import { Photo } from "../data/photography";
type PhotoInterludeProps = {
  image: Photo;
  statement: string;
  label?: string;
  align?: "left" | "right";
};
export function PhotoInterlude({
  image,
  statement,
  label,
  align = "left"
}: PhotoInterludeProps) {
  return <section aria-label={label ?? "Interlude"} className="pb-24 md:pb-32" data-id="element-443" data-mp="3s24q1q954ffv">
      <div className="h-[52vh] min-h-[360px] max-h-[620px] w-full overflow-hidden bg-stone" data-id="element-444" data-mp="3s01qaei6r7xy">
        <img src={image.src} alt={image.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-445" data-mp="9mao9jxdqdrz" />
      </div>
      <div className="shell relative -mt-24 md:-mt-32" data-id="element-446" data-mp="4r55gtz9xf84">
        <div className={`max-w-xl border-t-2 border-oxblood bg-ivory px-8 py-10 md:px-12 md:py-12 ${align === "right" ? "ml-auto" : ""}`} data-id="element-447" data-mp="jl9yh6xsmhh3">
          {label && <p className="eyebrow text-oxblood" data-id="element-448" data-mp="2ldeizxcyqchs">{label}</p>}
          <p className={`font-display text-2xl italic leading-snug text-navy md:text-[2rem] ${label ? "mt-5" : ""}`} data-id="element-449" data-mp="2ldy39kq35cyz">
            {statement}
          </p>
        </div>
      </div>
    </section>;
}